export class ExcelGeneralLedgerDTO {
  public constructor(
    public id?: number,
    public transactionDate?: Date,
    public journalEntry?: string,
    public description?: string,
    public debit?: number,
    public credit?: number,
    public isManualEntry?: boolean,
    public accountCode?: string,
    public accountName?: string,
    public contraAccountCode?: string,
  ) {

  }
}
